//map route line style
import { v4 as uuidv4 } from "uuid"
import definitionIcon from "../../assets/images/history_edu.svg"
import metricIcon from "../../assets/images/analytics.svg"
import sourceIcon from "../../assets/images/description.svg"

import { 
    monterreyMetroplex,
    torreon,
    queretaroMetroplex,
    sanLuisPotosiMetroplex,
    ciudadJuarez,
    hermosillo,
    tijuana,
    guadalajaraMetroplex,
    saltillo,
    leon,
} from "../../utils/globalUtils.js"

export const LAYER_STYLE = {
    id: 'line',
    type: 'line',
    paint: {
        'line-color': ['interpolate', ['linear'], ['line-progress'], 0, '#009AFF', 1, '#8CA5FF'],
        'line-width': 2,
        'line-opacity': 1,
    },
};

export const MEXICO_CENTER = [-101.5742, 23.54739]

const TOTAL_PAYROLL_COST = "65cd417ff955fa725381e7e7"
export const LOGISTICS_COST = "65cd419ff955fa725381e7e8"
const TOTAL_ELECTRICITY_COST = "65cd41a8f955fa725381e7e9"
const TOTAL_WATER_COST = "65cd41b0f955fa725381e7ea"
const TOTAL_GAS_COST = "65cd41b9f955fa725381e7eb"
const AVERAGE_LAND_COST = "65cd41c4f955fa725381e7ec"

const TURNOVER_RATE = "65cd4263f955fa725381e7f2"
const MANUFACTURING_DENSITY = "65cd425cf955fa725381e7f1"
const MANUFACTURING_GROWTH = "65cd4254f955fa725381e7f0"
const SKILLED_LABOR_SIMILAR_MFG_COMPANIES = "65cd424af955fa725381e7ef"
const ENGINEER_GRADUATES_MANUFACTURING_ACTIVITIES = "65cd4242f955fa725381e7ee"
const TSU_GRADUATES = "65cd4238f955fa725381e7ed"

const ABSENTEEISM = "65cd42a0f955fa725381e7f6"
const UNION_ENVIRONMENT = "65cd429af955fa725381e7f5"
const INDIVIDUAL_LABOR_LAWSUITS = "65cd4294f955fa725381e7f4"
const COLLECTIVE_CONFLICTS = "65cd428ef955fa725381e7f3"

const DISTANCE_TO_CLIENT = "65cd42c0f955fa725381e7f9"
const DISTANCE_TO_SEAPORT = "65cd42baf955fa725381e7f8"
const DISTANCE_TO_SUPPLIER = "65cd42b5f955fa725381e7f7"

export const CONNECTIVITY_TRAVEL = "65cd42daf955fa725381e7fc"
const AVAILABILITY_OF_POTENTIAL_LAND = "65cd42d4f955fa725381e7fb"
const TOTAL_FOREIGN_INVESTMENT = "65cd42caf955fa725381e7fa"

const GOVERNMENT_INCENTIVES = "65cd42f3f955fa725381e7fe"
export const GOVERNMENT_LANDSCAPE = "65cd42ecf955fa725381e7fd"

const HOMICIDES = "65cd4321f955fa725381e804"
const CAR_THEFT = "65cd431af955fa725381e803"
const HOME_THEFT = "65cd4314f955fa725381e802"
const ORGANIZED_CRIME_PRESENCE = "65cd430ef955fa725381e801"
const INSECURITY_PERCEPTION = "65cd4307f955fa725381e800"
const CORRUPTION_INDEX = "65cd4302f955fa725381e7ff"

const PRIVATE_SCHOOLS = "65cd436af955fa725381e80b"
const PRIVATE_HOSPITALS = "65cd4364f955fa725381e80a"
const RECOGNIZED_RETAIL_CHAINS_IN_THE_CITY = "65cd435df955fa725381e809"
const COST_OF_LIVING = "65cd4355f955fa725381e808"
const HIGHER_TEMPERATURE_PEAKS = "65cd434ef955fa725381e807"
const HUMIDITY_DAYS = "65cd4347f955fa725381e806"
const SOCIAL_PROGRESS_INDEX = "65cd4340f955fa725381e805"

export const VAR_BLOCKED = [
    TOTAL_WATER_COST,
    TURNOVER_RATE,
    MANUFACTURING_DENSITY,
    SKILLED_LABOR_SIMILAR_MFG_COMPANIES,
    ABSENTEEISM,
    UNION_ENVIRONMENT,
    COLLECTIVE_CONFLICTS,
    DISTANCE_TO_SUPPLIER,
    DISTANCE_TO_SEAPORT,
    AVAILABILITY_OF_POTENTIAL_LAND,
    GOVERNMENT_INCENTIVES,
    INSECURITY_PERCEPTION,
    CORRUPTION_INDEX,
    PRIVATE_SCHOOLS,
    PRIVATE_HOSPITALS,
    COST_OF_LIVING
]

export const AIRPORTS = {
    [monterreyMetroplex]: "Aeropuerto Internacional General Mariano Escobedo",
    [torreon]: "Aeropuerto Internacional Francisco Sarabia",
    [queretaroMetroplex]: "Aeropuerto Internacional de Querétaro",
    [sanLuisPotosiMetroplex]: "Aeropuerto Internacional Ponciano Arriaga",
    [ciudadJuarez]: "Aeropuerto Internacional Abraham González",
    [hermosillo]: "Aeropuerto Internacional General Ignacio Pesqueira García",
    [tijuana]: "Aeropuerto Internacional General Abelardo L.",
    [guadalajaraMetroplex]: "Aeropuerto Internacional Miguel Hidalgo y Costilla",
    [saltillo]: "Aeropuerto Internacional Plan de Guadalupe",
    [leon]: "Aeropuerto Internacional Del Bajío",
}

export const POLITICS = {
    [monterreyMetroplex]: {
        stateElections: "2027",
        partyInPower: "Movimiento Ciudadano",
        federalGovernment: "Morena",
    },
    [torreon]: {
        stateElections: "2027",
        partyInPower: "Partido Revolucionario Institucional",
        federalGovernment: "Morena",
    },
    [queretaroMetroplex]: {
        stateElections: "2027",
        partyInPower: "Partido Accion Nacional	",
        federalGovernment: "Morena",
    },
    [sanLuisPotosiMetroplex]: {
        stateElections: "2027",
        partyInPower: "Partido Verde Ecologista",
        federalGovernment: "Morena",
    },
    [ciudadJuarez]: {
        stateElections: "2027",
        partyInPower: "Partido Accion Nacional",
        federalGovernment: "Morena",
    },
    [hermosillo]: {
        stateElections: "2027",
        partyInPower: "Morena",
        federalGovernment: "Morena",
    },
    [tijuana]: {
        stateElections: "2027",
        partyInPower: "Morena",
        federalGovernment: "Morena",
    },
    [guadalajaraMetroplex]: {
        stateElections: "2027",
        partyInPower: "Movimiento Ciudadano",
        federalGovernment: "Morena",
    },
    [saltillo]: {
        stateElections: "2027",
        partyInPower: "Partido Revolucionario Institucional",
        federalGovernment: "Morena",
    },
    [leon]: {
        stateElections: "2027",
        partyInPower: "Partido Accion Nacional",
        federalGovernment: "Morena",
    },
}

export const HEADER_DESCRIPTION = {
    criterion: "Concept to be evaluated for the selection of the city.",
    points: "Total score awarded according to percentages assigned by the client.",
    weight: "Importance of the criterion to be evaluated according to the interests of the project.",
    cities: ""
}

export const DETAILS_TOTAL_TITLE = {
    [TOTAL_PAYROLL_COST]: "Total payroll annual",
    [LOGISTICS_COST]: "Consolidated inbound & outbound costs",
    [TOTAL_ELECTRICITY_COST]: "Estimated Annual Cost",
    [TOTAL_WATER_COST]: "Estimated Annual Cost",
    [TOTAL_GAS_COST]: "Estimated Annual Cost",
    [AVERAGE_LAND_COST]: "Estimated Annual Cost",

    [MANUFACTURING_GROWTH]: "Growth of IMMEX Establishment Plants Last 5 Years(Units)",
    [ENGINEER_GRADUATES_MANUFACTURING_ACTIVITIES]: "AVG Engineering graduates per year",
    [TSU_GRADUATES]: "AVG TSU Graduates per year",

    [INDIVIDUAL_LABOR_LAWSUITS]: "AVG lawsuits of Last 4 years",

    [DISTANCE_TO_CLIENT]: "Total truck hours",

    [HOMICIDES]: "Ratio per 100,000 population",
    [CAR_THEFT]: "Ratio per 100,000 population",
    [HOME_THEFT]: "Ratio per 100,000 population",
    [ORGANIZED_CRIME_PRESENCE]: "Ratio per 100,000 population",
    
    [RECOGNIZED_RETAIL_CHAINS_IN_THE_CITY]: "Ratio per 100,000 population",
    [SOCIAL_PROGRESS_INDEX]: "Social progress index",
}

export const INFO_TOOLTIP = [
    {
        id: uuidv4(),
        image: definitionIcon,
        title: "Definition",
        accessKey: "definition"
    },
    {
        id: uuidv4(),
        image: metricIcon,
        title: "Metric",
        accessKey: "metric"
    },
    {
        id: uuidv4(),
        image: sourceIcon,
        title: "Source",
        accessKey: "source"
    },
]

export const STREETVIEW_LOCATIONS = [
    {
        cityId: monterreyMetroplex,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@25.6757331,-100.2820756,3a,75y,322.74h,107.68t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@25.6668929,-100.3818539,3a,75y,45.27h,119.4t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: torreon,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/place/Telef%C3%A9rico+Torre%C3%B3n+-+Estaci%C3%B3n+Cristo+de+las+Noas/@25.52615,-103.4571402,3a,75y,99.94h,82.26t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@25.5382432,-103.4618637,3a,75y,213.86h,110.22t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: queretaroMetroplex,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/place/Templo+de+Santa+Rosa+de+Viterbo/@20.5885056,-100.3965523,3a,75y,163.61h,108.92t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/place/Juriquilla,+Qro./@20.6948196,-100.4456353,3a,75y,142.43h,97.46t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: sanLuisPotosiMetroplex,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@22.1309637,-101.0196855,3a,75y,206.36h,94.42t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@22.1285405,-101.033912,3a,75y,314.26h,88.83t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: ciudadJuarez,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@31.6903589,-106.4251754,3a,75y,67.08h,87.37t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@31.7383624,-106.4868304,3a,75y,11.83h,108.26t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: hermosillo,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/place/Catedral+Metropolitana+de+Nuestra+Se%C3%B1ora+de+la+Asunci%C3%B3n/@29.0755306,-110.9597306,3a,75y,191.59h,105.91t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@29.0611383,-111.0514526,3a,75y,341.08h,101.21t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: tijuana,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@32.5331239,-117.0253546,3a,75y,7.53h,80.07t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@32.5300887,-117.0248848,3a,75y,96.25h,97.06t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: guadalajaraMetroplex,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@20.7092386,-103.4129962,3a,75y,203.26h,99.9t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@20.7227179,-103.4170908,3a,75y,298.44h,107.44t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: saltillo,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@25.4408267,-100.9925875,3a,75y,111.18h,93.67t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@25.4249122,-101.0078297,3a,75y,255.5h,86.76t/"),
                    },
                ]
            }
        ]
    },
    {
        cityId: leon,
        groups: [
            {
                id: uuidv4(),
                title: "Teaser",
                locations: [
                    {
                        id: uuidv4(),
                        title: "Location 1",
                        ...handleLocationUrl("https://www.google.com/maps/@21.0015243,-101.5075392,3a,75y,298.7h,90.68t/"),
                    },
                    {
                        id: uuidv4(),
                        title: "Location 2",
                        ...handleLocationUrl("https://www.google.com/maps/@21.0009283,-101.5091633,3a,75y,323.16h,90.96t/"),
                    },
                ]
            }
        ]
    },
]

function handleLocationUrl(url) {
    const handledUrl = url?.split("@")[1]
    
    const lng = +(handledUrl?.split(",")[1])
    const lat = +(handledUrl?.split(",")[0])
    const heading = +(handledUrl?.split(",")[4].split("h")[0])
    const pitch = handledUrl?.split(",")[5].split("t")[0]
    const zoom = handledUrl?.split(",")[3].split("y")[0]

    const calculatedPitch = -90 + ((180/178) * (+pitch - 1))
    const calculatedZoom = 4 - ((4/75) * (+zoom - 15))
    
    return {
        longitude: lng,
        latitude: lat,
        heading,
        pitch: calculatedPitch,
        zoom: calculatedZoom
    }
}

export function addCommas(value) {
    if (value?.toString()?.includes(".")) return value?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')

    return value?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

export function getTotalCategoryWeight(categories) {
    return categories.reduce((acc, curr) => {
        return acc + curr.weight
    }, 0)
}

export function calculateCenter(start, end) {
    const newLngCenter = (start[0] + end[0]) / 2
    const newLatCenter = (start[1] + end[1]) / 2

    return [newLngCenter, newLatCenter]
}

export function calculateZoom(start, end) {                    //calculate the appropiate zoom of the map
    const R = 6371; // Earth's radius in kilometers
    const dLat = (end[1] - start[1]) * (Math.PI / 180);
    const dLon = (end[0] - start[0]) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(start[1] * (Math.PI / 180)) * Math.cos(end[1] * (Math.PI / 180)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const distance = R * c; // Distance in kilometers

    if (distance > 2400.8825180123054) return 3.5
    if (distance > 2000.541144483979 && distance <= 2400.8825180123054) return 4
    if (distance > 1600.1472920255646 && distance <= 2000.541144483979) return 4.5
    if (distance > 1100.9233141416778 && distance <= 1600.1472920255646) return 5
    if (distance > 900.0559377080356 && distance <= 1100.9233141416778) return 5.5
    if (distance > 500.1684068131266 && distance <= 900.0559377080356) return 6
    if (distance <= 500.1684068131266) return 6.5
}

export const getImages = async (cities) => {
    const photoPromises = cities.map(async city => {
        const cityName = city.municipality_name.replace(" Metroplex", "")
        const photo = await fetchPhoto(cityName + ", " + city.state_name);
        city.urlPhoto = photo
        return city;
    });

    return await Promise.all(photoPromises);
}

const fetchPhoto = async (city) => {
    return new Promise((resolve, reject) => {
        if (!window.google || !window.google.maps) {
            return;
        }
        
        const request = {
            query: city,
            fields: ['name', 'geometry', 'photos'],
        };

        const service = new window.google.maps.places.PlacesService(document.createElement('div'));

        service.findPlaceFromQuery(request, (results, status) => {
            if (window.google && status === window.google.maps.places.PlacesServiceStatus.OK) {
                resolve(results[0].photos[0].getUrl({ 'maxWidth': results[0].photos[0].height, 'maxHeight': results[0].photos[0].width }))
            }
        });
    })
}